import { Trans } from '@lingui/react/macro'
import { AppError } from '@jotta/types/AppError'
import { PublicLayout } from '../components/Layout/PublicLayout'
import { FormattedContent } from '@jotta/ui/FormattedContent'
import { useLocation } from 'react-router-dom'

export function AfterTerminate({
  skipLocationCheck,
}: {
  skipLocationCheck?: boolean
}) {
  const location = useLocation()

  if (!skipLocationCheck && !location.state?.fromApp) {
    throw new AppError({ HTTPStatus: 404 })
  }

  return (
    <PublicLayout section="afterterminate">
      <div className="w-full p-16">
        <FormattedContent
          variant="formats.errorPage"
          className="md:justify-self-start"
        >
          <h2>
            <Trans>Your account is terminated</Trans>
          </h2>
          <p>
            <Trans>
              We're really sorry to lose you. Remember - you're always welcome
              back.
            </Trans>
          </p>
          <p>
            <a href="/" className="link">
              <Trans>Click here to go back to the homepage.</Trans>
            </a>
          </p>
        </FormattedContent>
      </div>
    </PublicLayout>
  )
}
